import { makeStyles } from 'tss-react/mui';

const name = 'TrafficChart';

export const useTrafficChartStyles = makeStyles({ name })(theme => ({
  root: {
    border: `1px solid ${theme.palette.divider}`,
    height: 300,
  },
}));
